module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Er-Hao_Poster-35585a91595b0f035481d7ff76a9890e.webp";